var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sensorData)?_c('IxVectorLayer',{attrs:{"features":_vm.features,"vector-style":_vm.style,"z-index":1,"layer-id":"sensorData","auto-focus":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }